import React from "react";
import { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { Paper } from "@material-ui/core";
import useUserQueries from "../../../hooks/useUserQueries";
import { useQuery } from "react-query";
import Loading from "../../../../../components/Loading";
import { mutateErrors } from "../../../../../utils";
import Error from "../../../../../components/Error";
import { useAuth } from "../../../../auth/hooks/useAuth";
import Container from "@material-ui/core/Container";
import PageHeader from "../../../../../components/PageHeader";
import Button from "../../../../../components/Button";
import { AdapterLink } from "../../../../../components/Adopter";
import { Routes } from "../../../../../constants/routes";
import StudentsList from "../../../components/StudentsList";
import { QUERY_KEYS } from "../../../../../constants";
import { UserRole } from "../../../enums/UserRole";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  paper: {
    padding: theme.spacing(3),
  },
}));

const StudentsPage: FC = () => {
  const classes = useStyles();

  const { user } = useAuth();

  const { adminUsersList } = QUERY_KEYS;

  const { fetchStudents, fetchAll } = useUserQueries();

  const { isLoading, isFetching, isError, refetch, error, data } =
    useQuery<any>([adminUsersList, UserRole.Student], () =>
      user.role === UserRole.Agent
        ? fetchStudents()
        : fetchAll(UserRole.Student),
    );

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  const students = data.data;

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={"Students"}
          subtitle={"Here are listed your students"}
          endAdornment={
            user.role === 2 && (
              <Button
                color={"success"}
                variant={"contained"}
                component={AdapterLink}
                to={`/0/${Routes.USER_STUDENTS}/add`}
              >
                Add
              </Button>
            )
          }
        />
      </Container>

      <Container maxWidth="lg" className={classes.container}>
        <Paper className={classes.paper}>
          <StudentsList students={students} refetch={refetch} />
        </Paper>
      </Container>
    </>
  );
};

export default React.memo(StudentsPage);
